// removed by extract-text-webpack-plugin
module.exports = {"aboutExtra":"src-layouts-components----Extra-module---aboutExtra---1yez9","extrasContainer":"src-layouts-components----Extra-module---extrasContainer---2Boh5","extra":"src-layouts-components----Extra-module---extra---2UDqk"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/components/Extra.module.css
// module id = 307
// module chunks = 114276838955818